import jQuery from './jquery';
import { initContactForm } from './modules/helpers';

window.jQuery = jQuery;
window.$ = window.jQuery;

(() => {
  $(document).ready(() => {
    if ($('.contact-form').length) initContactForm();
  }).scroll(() => {
    if ($(window).scrollTop() > 20) {
      $('.top-bar').addClass('page-scrolled', 300);
    } else {
      $('.top-bar').removeClass('page-scrolled', 300);
    }
  });
})();
